// Rótulo "Emprestada até DD/MM" para casas em movimento temporário entre equipes.
// client.team_temp_return.return_date é o dia SEGUINTE ao fim do empréstimo,
// então o último dia (até quando fica) é return_date - 1.
export function borrowedUntilLabel(client) {
  const rd = client?.team_temp_return?.return_date;
  if (!rd) return null;
  const d = new Date(rd + "T00:00:00");
  d.setDate(d.getDate() - 1);
  return d.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit" });
}
